export function Loading() {
  return (
    <p className="app-loading" role="status" aria-live="polite">
      Carregando…
    </p>
  )
}
